import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonLayoutModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { ImageViewEditorComponent } from './component/image-view-editor/image-view-editor.component';
import { ImageViewComponent } from './component/image-view/image-view.component';


@NgModule({
  declarations: [
    ImageViewComponent,
    ImageViewEditorComponent
  ],
  imports: [
    CommonModule,
    ApplicationClientCommonModule,
    CommonLayoutModule,
    CommonTranslationModule,
    MatButtonModule
  ]
})
export class ImageViewModule { }
